import { render, staticRenderFns } from "./DashboardAppInfo.vue?vue&type=template&id=f91f0852"
import script from "./DashboardAppInfo.vue?vue&type=script&lang=ts"
export * from "./DashboardAppInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports